/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Divider,
  Typography,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
  FormGroup,
  Checkbox,
  Tooltip,
  Button,
  Menu,
  MenuItem,
  Box,
  IconButton,
} from "@common-ui/ui";
import {
  CheckCircle,
  CircleOutlined,
  Error,
  Cancel,
  NotInterested,
  CheckBox,
} from "@mui/icons-material";
import WrapTextOutlinedIcon from "@mui/icons-material/WrapTextOutlined";

import { FrameRenderer } from "../Renderer";
import { putFile, getFileAsObject, configure } from "@plat/domain-api";
import { getSessionToken } from "../../../services/getToken";

import { workItemsSlice } from "../../../reducers/workItemsReducer";
import { updateStepStatus } from "../../../services/procedureRuntime";

const isValidURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
};
const Status = ({
  groupItem,
  stepNum,
  config,
  defaultValue,
  fieldValue,
  setFieldValue,
  disabled,
  status,
  statusWarn,
  mode,
}) => {
  const [statusToDisplay, setStatusToDisplay] = React.useState(status);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setStatusToDisplay(status);
  }, [status]);

  return (
    <Box>
      <Tooltip
        placement="left-start"
        title="Select Result Code"
        disableFocusListener={mode === "VIEW" || mode === "REPORT_VIEW"}
        disableHoverListener={mode === "VIEW" || mode === "REPORT_VIEW"}
        disableTouchListener={mode === "VIEW" || mode === "REPORT_VIEW"}
      >
        <div>
          <IconButton
            id="generate"
            size="small"
            variant="outlined"
            disabled={mode === "VIEW" || mode === "REPORT_VIEW"}
            sx={{ fontWeight: 200, mt: 1 }}
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            {groupItem?.type === "CUSTOM" ? (
              statusWarn ? (
                <Error color="warning" />
              ) : statusToDisplay === "PASS" ? (
                <CheckCircle color="success" />
              ) : statusToDisplay === "FAIL" ? (
                <Cancel color="error" />
              ) : statusToDisplay === "N/A" ? (
                <NotInterested color="warning" />
              ) : statusToDisplay === "WARN" ? (
                <Error color="warning" />
              ) : statusToDisplay === "SKIPPED" ? (
                <WrapTextOutlinedIcon
                  style={{
                    color: "#1e88e5",
                    border: "1px solid #1e88e5",
                    borderRadius: "50%",
                  }}
                />
              ) : statusToDisplay === "PERFORMED" ? (
                <CheckBox color="primary" />
              ) : (
                "---"
              )
            ) : statusWarn ? (
              <Error color="warning" />
            ) : statusToDisplay === "PASS" ? (
              <CheckCircle color="success" />
            ) : statusToDisplay === "FAIL" ? (
              <Cancel color="error" />
            ) : statusToDisplay === "N/A" ? (
              <NotInterested color="warning" />
            ) : statusToDisplay === "SKIPPED" ? (
              <WrapTextOutlinedIcon
                style={{
                  color: "#1e88e5",
                  border: "1px solid #1e88e5",
                  borderRadius: "50%",
                }}
              />
            ) : statusToDisplay === "PERFORMED" ? (
              <CheckBox sx={{ mr: 1 }} color="primary" />
            ) : statusToDisplay === "WARN" ? (
              <Error color="warning" />
            ) : (
              <CircleOutlined />
            )}
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {groupItem?.type === "TASK ITEM" ? (
              <>
                {" "}
                <MenuItem
                  onClick={(e) => {
                    setFieldValue({
                      ...fieldValue,
                      status: "PERFORMED",
                    });
                    setStatusToDisplay("PERFORMED");
                    handleClose(e);
                  }}
                >
                  <CheckBox sx={{ mr: 1 }} color="primary" /> Performed
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    setFieldValue({
                      ...fieldValue,
                      status: "SKIPPED",
                    });
                    setStatusToDisplay("SKIPPED");
                    handleClose(e);
                  }}
                >
                  <WrapTextOutlinedIcon
                    sx={{ mr: 1 }}
                    style={{
                      color: "#1e88e5",
                      border: "1px solid #1e88e5",
                      borderRadius: "50%",
                    }}
                  />{" "}
                  Skipped (Not Performed)
                </MenuItem>
                {groupItem?.na ? (
                  <MenuItem
                    onClick={(e) => {
                      setFieldValue({
                        ...fieldValue,
                        status: "N/A",
                      });
                      setStatusToDisplay("N/A");
                      handleClose(e);
                    }}
                  >
                    <NotInterested sx={{ mr: 1 }} color="warning" />
                    Not-Applicable
                  </MenuItem>
                ) : (
                  ""
                )}
              </>
            ) : (
              <>
                {" "}
                <MenuItem
                  onClick={(e) => {
                    setFieldValue({
                      ...fieldValue,
                      status: "PASS",
                    });
                    setStatusToDisplay("PASS");
                    handleClose(e);
                  }}
                >
                  <CheckCircle sx={{ mr: 1 }} color="success" /> Pass
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    setFieldValue({
                      ...fieldValue,
                      status: "FAIL",
                    });
                    setStatusToDisplay("FAIL");
                    handleClose(e);
                  }}
                >
                  <Cancel sx={{ mr: 1 }} color="error" /> Fail
                </MenuItem>
                {groupItem?.warn ? (
                  <MenuItem
                    onClick={(e) => {
                      setFieldValue({
                        ...fieldValue,
                        status: "WARN",
                      });
                      setStatusToDisplay("WARN");
                      handleClose(e);
                    }}
                  >
                    <Error sx={{ mr: 1 }} color="warning" /> Warn
                  </MenuItem>
                ) : (
                  ""
                )}
                <MenuItem
                  onClick={(e) => {
                    setFieldValue({
                      ...fieldValue,
                      status: "SKIPPED",
                    });
                    setStatusToDisplay("SKIPPED");
                    handleClose(e);
                  }}
                >
                  <WrapTextOutlinedIcon
                    sx={{ mr: 1 }}
                    style={{
                      color: "#1e88e5",
                      border: "1px solid #1e88e5",
                      borderRadius: "50%",
                      fontSize: "22px",
                    }}
                  />
                  Skip
                </MenuItem>
                {groupItem?.na ? (
                  <MenuItem
                    onClick={(e) => {
                      setFieldValue({
                        ...fieldValue,
                        status: "N/A",
                      });
                      setStatusToDisplay("N/A");
                      handleClose(e);
                    }}
                  >
                    <NotInterested sx={{ mr: 1 }} color="warning" />
                    Not-Applicable
                  </MenuItem>
                ) : (
                  ""
                )}
              </>
            )}
          </Menu>
        </div>
      </Tooltip>
    </Box>
  );
};

const Na = ({
  groupItem,
  stepNum,
  config,
  defaultValue,
  fieldValue,
  setFieldValue,
  status,
  mode,
}) => {
  let isView = mode === "VIEW" || mode === "REPORT_VIEW";
  let disabled = false;
  if (isView) {
    disabled = true;
  }
  return groupItem.na ? (
    <FormControl fullWidth name="na">
      {typeof defaultValue !== "string" ? (
        defaultValue["na"] === true ? (
          <Switch
            {...{ inputProps: { "aria-label": "Switch demo" } }}
            inputProps={{ "aria-label": "controlled" }}
            sx={{ mt: 1 }}
            size="small"
            disabled={disabled}
            name="na"
            onChange={async (e, value) => {
              setFieldValue({
                ...fieldValue,
                na: value,
                status:
                  value === true
                    ? "N/A"
                    : fieldValue?.yes_no || fieldValue?.pass_fail,
              });
            }}
            defaultChecked
          />
        ) : (
          <Switch
            {...{ inputProps: { "aria-label": "Switch demo" } }}
            inputProps={{ "aria-label": "controlled" }}
            sx={{ mt: 1 }}
            size="small"
            name="na"
            disabled={disabled}
            onChange={async (e, value) => {
              setFieldValue({
                ...fieldValue,
                na: value,
                status:
                  value === true
                    ? "N/A"
                    : fieldValue?.yes_no || fieldValue?.pass_fail,
              });
            }}
          />
        )
      ) : (
        <Switch
          {...{ inputProps: { "aria-label": "Switch demo" } }}
          inputProps={{ "aria-label": "controlled" }}
          sx={{ mt: 1 }}
          size="small"
          name="na"
          disabled={disabled}
          onChange={async (e, value) => {
            setFieldValue({
              ...fieldValue,
              na: value,
              status:
                value === true
                  ? "N/A"
                  : fieldValue?.yes_no || fieldValue?.pass_fail,
            });
          }}
        />
      )}
    </FormControl>
  ) : (
    <Typography sx={{ mt: 1.5 }}>---</Typography>
  );
};

const Warn = ({
  groupItem,
  stepNum,
  config,
  defaultValue,
  fieldValue,
  setFieldValue,
  mode,
}) => {
  let isView = mode === "VIEW" || mode === "REPORT_VIEW";
  let disabled = false;
  if (isView) {
    disabled = true;
  }
  return groupItem.warn ? (
    <FormControl fullWidth name="warn">
      {typeof defaultValue !== "string" ? (
        defaultValue["warn"] === true ? (
          <Switch
            {...{ inputProps: { "aria-label": "Switch demo" } }}
            inputProps={{ "aria-label": "controlled" }}
            sx={{ mt: 1 }}
            size="small"
            name="warn"
            onChange={async (e, value) => {
              setFieldValue({ ...fieldValue, warn: value });
            }}
            disabled={disabled}
            defaultChecked
          />
        ) : (
          <Switch
            {...{ inputProps: { "aria-label": "Switch demo" } }}
            inputProps={{ "aria-label": "controlled" }}
            sx={{ mt: 1 }}
            size="small"
            disabled={disabled}
            name="warn"
            onChange={async (e, value) => {
              setFieldValue({ ...fieldValue, warn: value });
            }}
          />
        )
      ) : (
        <Switch
          {...{ inputProps: { "aria-label": "Switch demo" } }}
          inputProps={{ "aria-label": "controlled" }}
          sx={{ mt: 1 }}
          size="small"
          disabled={disabled}
          name="warn"
          onChange={async (e, value) => {
            setFieldValue({ ...fieldValue, warn: value });
          }}
        />
      )}
    </FormControl>
  ) : (
    <Typography sx={{ mt: 1.5 }}>---</Typography>
  );
};

const Result = ({
  groupItem,
  stepNum,
  config,
  defaultValue,
  fieldValue,
  setFieldValue,
  disabled,
  status,
  mode,
}) => {
  let isView = mode === "VIEW" || mode === "REPORT_VIEW";
  if (isView) {
    disabled = true;
  }
  switch (groupItem.type) {
    case "YES/NO":
      return (
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="select-pass-fail-type"
            name="yes-no-type"
            onChange={async (e, value) => {
              setFieldValue({
                ...fieldValue,
                yes_no: value,
                status:
                  groupItem.test_types === "AFFIRMATIVE_PASS"
                    ? value === "YES"
                      ? "PASS"
                      : "FAIL"
                    : value === "YES"
                    ? "FAIL"
                    : "PASS",
              });
            }}
            defaultValue={() => {
              // check if status
              return defaultValue?.yes_no;
            }}
          >
            <FormControlLabel
              value="YES"
              control={disabled ? <Radio disabled={disabled} /> : <Radio />}
              label="Yes"
            />
            <FormControlLabel
              value="NO"
              control={disabled ? <Radio disabled={disabled} /> : <Radio />}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      );
    case "PASS/FAIL":
      return (
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="select-pass-fail-type"
            name="pass-fail-type"
            onChange={async (e, value) => {
              setFieldValue({
                ...fieldValue,
                pass_fail: value,
                status: value,
              });
            }}
            defaultValue={() => {
              // check if status
              return defaultValue.pass_fail;
            }}
          >
            <FormControlLabel
              value="PASS"
              control={disabled ? <Radio disabled={disabled} /> : <Radio />}
              label="Pass"
            />
            <FormControlLabel
              value="FAIL"
              control={disabled ? <Radio disabled={disabled} /> : <Radio />}
              label="Fail"
            />
          </RadioGroup>
        </FormControl>
      );
    case "TASK ITEM":
      return (
        <FormControl>
          <FormGroup>
            {Array(Number(groupItem.repeat))
              .fill(0)
              .map((item, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    name={`${groupItem.id}_${index}`}
                    control={
                      typeof defaultValue !== "string" ? (
                        defaultValue[index] ? (
                          <Checkbox defaultChecked disabled={disabled} />
                        ) : (
                          <Checkbox disabled={disabled} />
                        )
                      ) : (
                        <Checkbox disabled={disabled} />
                      )
                    }
                    label={groupItem.checkbox_label}
                    onChange={async (e, value) => {
                      let completed = fieldValue?.completed
                        ? [...fieldValue["completed"], index]
                        : [index];
                      if (value !== true) {
                        completed = fieldValue?.completed
                          ? [...fieldValue["completed"], index].filter(
                              (v) => v !== index
                            )
                          : [];
                      }
                      setFieldValue({
                        ...fieldValue,
                        [index]: value,
                        completed: completed,
                        status:
                          completed?.length === Number(groupItem.repeat)
                            ? "PASS"
                            : false,
                      });
                    }}
                  />
                );
              })}
          </FormGroup>
        </FormControl>
      );

    default:
      return <Typography sx={{ mt: 1.5 }}>---</Typography>;
  }
};

const DisplayRow = ({
  groupItem,
  sectionId,
  sectionStep,
  rowProp,
  orgID,
  IconButton,
  mode,
}) => {
  const dispatch = useDispatch();
  const stepNum = groupItem.number;
  const [config, setConfig] = useState({
    workEventId: rowProp.work_event,
    workItemId: String(rowProp.id),
    organization: orgID,
    application: "Platform",
    stepNum: String(stepNum).trim(),
  });
  const [defaultValue, setDefaultValue] = useState(undefined);
  const [fieldValue, setFieldValue] = useState(defaultValue);
  const [disabled, setDisabled] = useState(undefined);
  const [status, setStatus] = useState(undefined);
  const [statusWarn, setStatusWarn] = useState(undefined);

  useEffect(() => {
    getDefaultValue();
  }, [JSON.stringify(rowProp)]);

  useEffect(() => {
    async function upload() {
      // setGroupFieldValue({ ...groupFieldValue, [groupItem.id]: fieldValue });
      configure({
        ...config,
        authToken: await getSessionToken(),
      });
      // console.log("{...defaultValue, ...fieldValue}", {...defaultValue, ...fieldValue})
      putFile(
        JSON.stringify({ ...defaultValue, ...fieldValue }),
        groupItem.id,
        "application/json"
      );
      async function saveStatus() {
        // if (groupItem.type === "CUSTOM") return;
        try {
          let svStatus = "NOT_STARTED";
          let svStatusCode = "NOT_COMPLETED";
          if (fieldValue?.status === "PASS") {
            svStatus = "COMPLETED";
            svStatusCode = "PASS";
          }
          if (fieldValue?.status === "FAIL") {
            svStatus = "COMPLETED";
            svStatusCode = "FAIL";
          }
          if (fieldValue?.status === "N/A") {
            svStatus = "COMPLETED";
            svStatusCode = "NA";
          }
          if (fieldValue?.status === "WARN") {
            svStatus = "COMPLETED";
            svStatusCode = "WARN";
          }
          if (fieldValue?.status === "SKIPPED") {
            svStatus = "COMPLETED";
            svStatusCode = "SKIPPED";
          }
          if (fieldValue?.na === true) {
            svStatus = "COMPLETED";
            svStatusCode = "NA";
          } else {
            svStatus = "STARTED";
            if (fieldValue?.status === "PASS") {
              svStatus = "COMPLETED";
              svStatusCode = "PASS";
            }
            if (fieldValue?.status === "FAIL") {
              svStatus = "COMPLETED";
              svStatusCode = "FAIL";
            }
            if (fieldValue?.status === "SKIPPED") {
              svStatus = "COMPLETED";
              svStatusCode = "SKIPPED";
            }
            if (fieldValue?.status === "WARN") {
              svStatus = "COMPLETED";
              svStatusCode = "WARN";
            }
          }
          if (fieldValue?.warn === true) {
            svStatus = "COMPLETED";
            svStatusCode = "WARN";
          }
          // console.log("states", {
          //   status: svStatus,
          //   result_code: svStatusCode,
          // });

          const newStatus = await updateStepStatus(
            config.organization,
            config.workEventId,
            config.workItemId,
            config.stepNum,
            {
              status: svStatus,
              result_code: svStatusCode,
            }
          );
          dispatch(
            workItemsSlice.actions.setProcedureStatus({
              workItemId: config.workItemId,
              status: newStatus,
            })
          );
          // console.log("UPDATED", fieldValue);
        } catch (error) {
          console.log(error);
        }
      }
      saveStatus();
    }
    if (JSON.stringify(defaultValue) !== JSON.stringify(fieldValue)) {
      upload();
    }

    setDisabled(
      { ...defaultValue, ...fieldValue }["na"] === true
        ? true
        : () => {
            switch (groupItem.type) {
              case "PASS/FAIL":
                setStatus(
                  { ...defaultValue, ...fieldValue }["pass_fail"]
                    ? { ...defaultValue, ...fieldValue }["pass_fail"]
                    : false
                );
                return false;
              case "YES/NO":
                setStatus(
                  { ...defaultValue, ...fieldValue }["yes_no"]
                    ? groupItem.test_types === "AFFIRMATIVE_PASS"
                      ? { ...defaultValue, ...fieldValue }["yes_no"] === "YES"
                        ? "PASS"
                        : "FAIL"
                      : { ...defaultValue, ...fieldValue }["yes_no"] === "YES"
                      ? "FAIL"
                      : "PASS"
                    : false
                );
                return false;
              case "TASK ITEM":
                let completed = { ...defaultValue, ...fieldValue }?.completed;
                setStatus(
                  completed?.length === Number(groupItem.repeat)
                    ? "PASS"
                    : false
                );
                return false;

              default:
                return false;
            }
          }
    );
    // Warn
    setStatusWarn(
      { ...defaultValue, ...fieldValue }["na"] === true
        ? { ...defaultValue, ...fieldValue }["warn"] === true
          ? true
          : () => {
              setStatus("N/A");
              return false;
            }
        : { ...defaultValue, ...fieldValue }["warn"] === true
        ? true
        : () => {
            switch (groupItem.type) {
              case "PASS/FAIL":
                setStatus(
                  { ...defaultValue, ...fieldValue }["pass_fail"]
                    ? { ...defaultValue, ...fieldValue }["pass_fail"]
                    : false
                );
                return false;
              case "YES/NO":
                setStatus(
                  { ...defaultValue, ...fieldValue }["yes_no"]
                    ? groupItem.test_types === "AFFIRMATIVE_PASS"
                      ? { ...defaultValue, ...fieldValue }["yes_no"] === "YES"
                        ? "PASS"
                        : "FAIL"
                      : { ...defaultValue, ...fieldValue }["yes_no"] === "YES"
                      ? "FAIL"
                      : "PASS"
                    : false
                );
                return false;
              case "TASK ITEM":
                let completed = { ...defaultValue, ...fieldValue }?.completed;
                setStatus(
                  completed?.length === Number(groupItem.repeat)
                    ? "PASS"
                    : false
                );
                return false;

              default:
                return false;
            }
          }
    );
    setStatus(
      { ...defaultValue, ...fieldValue }["status"]
        ? { ...defaultValue, ...fieldValue }["status"]
        : false
    );
  }, [JSON.stringify(fieldValue)]);

  async function getDefaultValue() {
    try {
      configure({
        ...config,
        authToken: await getSessionToken(),
      });
      const value = await getFileAsObject(groupItem.id);
      setDefaultValue(value);
      setDisabled(value["na"] === true ? true : false);
      setStatusWarn(value["warn"] === true ? true : false);
      setStatus(value["status"] ? value["status"] : false);
    } catch (error) {
      // setDefaultValue("NOT_FOUND", stepNum);
      setDefaultValue("NOT_FOUND");
      setDisabled(false);
      setStatusWarn(false);
      setStatus(false);
      // console.log("error", error);
    }
  }
  return (
    <Grid key={groupItem.id} container spacing={1}>
      <Grid item md={0.5} xs={12}>
        <Typography fontWeight="700" sx={{ mt: { md: 1.5 } }}>
          {stepNum}
        </Typography>
      </Grid>

      <Grid item md={3} xs={12}>
        <div>
          <Typography sx={{ mt: 1.5 }}>{groupItem.label}</Typography>
        </div>
      </Grid>
      <Grid item md={3} xs={12}>
        <div>
          <Typography sx={{ mt: 1.5 }}>{groupItem.description}</Typography>
        </div>
      </Grid>
      <Grid item md={3} xs={12}>
        <div>
          {defaultValue && disabled !== undefined ? (
            <Result
              groupItem={groupItem}
              stepNum={stepNum}
              defaultValue={defaultValue}
              config={config}
              fieldValue={fieldValue}
              setFieldValue={setFieldValue}
              disabled={disabled}
              mode={mode}
            />
          ) : (
            "loading..."
          )}
        </div>
      </Grid>
      <Grid item md={1} xs={12}>
        {defaultValue && disabled !== undefined ? (
          <Na
            groupItem={groupItem}
            stepNum={stepNum}
            defaultValue={defaultValue}
            config={config}
            fieldValue={fieldValue}
            setFieldValue={setFieldValue}
            status={status}
            mode={mode}
          />
        ) : (
          "loading..."
        )}
      </Grid>
      <Grid item md={1} xs={12}>
        {defaultValue && disabled !== undefined ? (
          <Warn
            groupItem={groupItem}
            stepNum={stepNum}
            defaultValue={defaultValue}
            config={config}
            fieldValue={fieldValue}
            setFieldValue={setFieldValue}
            mode={mode}
          />
        ) : (
          "loading..."
        )}
      </Grid>
      <Grid item md={0.5} xs={12}>
        <div>
          <div>
            {defaultValue && disabled !== undefined ? (
              <Status
                groupItem={groupItem}
                stepNum={stepNum}
                defaultValue={defaultValue}
                config={config}
                fieldValue={fieldValue}
                setFieldValue={setFieldValue}
                disabled={disabled}
                status={status}
                statusWarn={statusWarn}
                mode={mode}
              />
            ) : (
              "loading..."
            )}
          </div>
        </div>
      </Grid>
      {groupItem.type === "CUSTOM" ? (
        <Grid item md={12} xs={12}>
          {String(groupItem?.url) !== "" ? (
            isValidURL(groupItem.url) ? (
              <FrameRenderer
                url={groupItem.url}
                configuration={groupItem?.configuration}
                {...rowProp}
                orgID={orgID}
                stepNum={stepNum}
                status={status}
                fieldValue={fieldValue}
                setFieldValue={setFieldValue}
                groupItem={groupItem}
                mode={mode}
              />
            ) : (
              "Invalid Domain App"
            )
          ) : (
            "Domain App not found"
          )}
        </Grid>
      ) : (
        ""
      )}
    </Grid>
  );
};
const Group = ({
  section,
  sectionItem,
  sectionId,
  sectionStep,
  rowProp,
  orgID,
  IconButton,
  procedureStatus,
  subSectionStep,
  subSectionId,
  mode,
}) => {
  let groupStatus = procedureStatus?.groups?.find(
    (item) =>
      String(item.section) === String(sectionItem.section_number) &&
      String(item.group) === String(sectionItem.number)
  );
  let subSection;
  if (subSectionId) {
    subSection = section.items.find((section) => section.id === subSectionId);
    groupStatus = procedureStatus?.groups?.find(
      (item) =>
        String(item.group) === String(sectionItem.number) &&
        String(item.section) === String(sectionItem.sub_section_number)
    );
  }
  // Deprecated
  const getStep = (id) => {
    if (subSection) {
      // console.log("subSection", subSection);
      return `${subSectionStep}.${
        Array.from(subSection.steps).indexOf(id) + 1
      }`;
    }
    return Array.from(section.steps).indexOf(id) + 1;
  };

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item md={0.5} xs={12}>
          <div>
            <Typography fontWeight="700">Step</Typography>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <Typography fontWeight="700">Label</Typography>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <Typography fontWeight="700">Description</Typography>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <Typography fontWeight="700">Result</Typography>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <Typography fontWeight="700">N/A</Typography>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <Typography fontWeight="700">Warn</Typography>
          </div>
        </Grid>
        <Grid item md={0.5} xs={12}>
          {groupStatus ? (
            <Typography fontWeight="700">{`${groupStatus["num_completed"]}/${groupStatus["num_steps"]}`}</Typography>
          ) : (
            <Typography fontWeight="700">N/A</Typography>
          )}
        </Grid>
      </Grid>
      <Divider sx={{ mt: 1 }} />
      {Array.from(sectionItem.items).map((groupItem) => {
        return (
          <DisplayRow
            key={groupItem.id}
            groupItem={groupItem}
            sectionId={sectionId}
            sectionStep={sectionStep}
            rowProp={rowProp}
            orgID={orgID}
            IconButton={IconButton}
            mode={mode}
          />
        );
      })}
      <Divider sx={{ my: 2 }} />
    </div>
  );
};

export default Group;
